<script>
import FavouritePropertyCard from "./favouritePropertyCard.vue";
import {mapActions} from "vuex";
import LoadingSkeleton from "../package/loadingSkeleton.vue";

export default {
  name: "favouritesListLayout",
  components: {LoadingSkeleton, FavouritePropertyCard},
  data() {
    return {
      dataValues: "",
      loading: false
    }
  },
  created() {
    this.getFavouriteList();
  },
  methods: {
    ...mapActions(["getFavourites"]),
    getFavouriteList() {
      this.loading = true;
      var that = this;
      that.getFavourites({
        pat: {
          page: 1,
          size: 8,
        },
        callback: that.callback
      });
    },
    callback(res) {
      var that = this;
      if (res.code == 0) {
        this.loading = false;
        res.data.forEach(v => {
          if (v.housePropertyPOJO.imageUrl) {
            if (v.housePropertyPOJO.imageUrl.indexOf(",") !== -1) {
              v.housePropertyPOJO.imgLst = v.housePropertyPOJO.imageUrl.split(
                ","
              );
            } else {
              v.housePropertyPOJO.imgLst = [v.housePropertyPOJO.imageUrl];
            }
          }
        });
        that.dataValues = res.data;
      } else if (res.code == 90000 || res.code == 90002) {
        this.loading = false;
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.code == 8902 || res.code == 8901) {
        this.loading = false;
        that.$box.alert("", res.message, "error");
      } else {
        this.loading = false;
        that.$box.alert("", res.message, "error");
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    removeFavourite(id) {
      this.dataValues = this.dataValues.filter(v =>
        v.housePropertyPOJO.propertyId !== id
      );
    },
  },

}
</script>

<template>

  <div class="favouritesListLayout">
    <el-row>
      <el-col :span="12">
        <span class="page-title">My Favourites</span>
      </el-col>
      <el-col :span="12" class="back-col">
        <span @click="goBack()" class="btn-back"><i class="el-icon-arrow-left"></i>BACK</span>
      </el-col>
    </el-row>
    <el-row >
      <el-divider></el-divider>
    </el-row>
    <el-row :gutter="20">
      <el-col
        :span="24" style="display: flex; justify-content: center;"
        v-if="
                    dataValues == null ||
                      dataValues == '' ||
                      dataValues == undefined
                  "
      >
        <loading-skeleton v-if="loading"></loading-skeleton>
        <span v-else
              style="padding:50px 0;;font-size:18px;color:#003333;"
        >
                    Nothing here yet! Explore and mark your favourites for quick access
                  </span>
      </el-col>
      <el-col
        :span="6"
        v-for="(item, index) in dataValues"
        :key="index"
        style="margin-top: 20px;"
      >
        <favourite-property-card :property="item" @removeFavourite="removeFavourite"/>
      </el-col>
    </el-row>
  </div>

</template>

<style scoped lang="css">
.favouritesListLayout {
  border-radius: 0 0 5px 5px;
  background-color: #ffffff;
  padding: 20px 10px 0 10px;
}
.btn-back {
  color: #003333;
  font-weight: 600;
  font-size: 24px;
  line-height: 125%;
  cursor: pointer;
  text-decoration: underline;
}
.back-col {
  display: flex;
  justify-content: flex-end;
}
.page-title {
  color: #003333;
  font-weight: 600;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/myFavourites/favouritesListLayout.vue